var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m232 0v32l48-16zm0 0",
    fill: "#ff6243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m136 96h192v368h-192zm0 0",
    fill: "#3d9ae2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m328 224h136v240h-136zm0 0",
    fill: "#5aaae7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bddbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m352 272h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 272h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 144h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 144h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 144h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 208h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 208h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 208h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 272h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 272h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 272h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 328h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 328h32v32h-32zm0 0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 224h136v240h-136zm0 0",
    fill: "#5aaae7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m80 272h32v32h-32zm0 0",
    fill: "#bddbff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24 272h32v32h-32zm0 0",
    fill: "#bddbff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m80 328h32v32h-32zm0 0",
    fill: "#bddbff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24 328h32v32h-32zm0 0",
    fill: "#bddbff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m184 352h48v112h-48zm0 0",
    fill: "#e6e7e8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m232 352h48v112h-48zm0 0",
    fill: "#d1d3d4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m136 96h192v16h-192zm0 0",
    fill: "#378bcc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m224 0h16v64h-16zm0 0",
    fill: "#ff9811"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m344 96v-32h-224v32zm0 0",
    fill: "#1e81ce"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.d54bf459.svg";
export { ForwardRef as ReactComponent };